import { render, staticRenderFns } from "./ShowNumerations.vue?vue&type=template&id=34d9d0f6"
import script from "./ShowNumerations.vue?vue&type=script&lang=js"
export * from "./ShowNumerations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d9d0f6')) {
      api.createRecord('34d9d0f6', component.options)
    } else {
      api.reload('34d9d0f6', component.options)
    }
    module.hot.accept("./ShowNumerations.vue?vue&type=template&id=34d9d0f6", function () {
      api.rerender('34d9d0f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/numerations/ShowNumerations.vue"
export default component.exports